import { render, staticRenderFns } from "./smsModule.vue?vue&type=template&id=1290fc4f&"
import script from "./smsModule.vue?vue&type=script&lang=js&"
export * from "./smsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports